/**
 * Oryx Tiny Dungeon Sprite Index
 * Maps sprite names to frame indices in spritesheets
 *
 * Spritesheets:
 * - world: 17 columns (267 tiles total)
 * - monsters: 29 columns (464 sprites total)
 * - items: 23 columns (92 items total)
 * - interface: various UI elements
 * - fx: effect sprites
 * - portraits: character portraits (24x24)
 */

// ============================================================================
// WORLD TILES (tiny_dungeon_world.png) - 17 columns
// ============================================================================
export const WORLD_TILES = {
  // Row 0: Basic floors
  FLOOR_STONE_A: 0,
  FLOOR_STONE_B: 1,
  FLOOR_STONE_C: 2,
  FLOOR_STONE_D: 3,
  FLOOR_COBBLE_A: 4,
  FLOOR_COBBLE_B: 5,
  FLOOR_COBBLE_C: 6,
  FLOOR_COBBLE_D: 7,
  FLOOR_COBBLE_E: 8,
  FLOOR_COBBLE_DRAIN: 9,
  FLOOR_DIRT_A: 10,
  FLOOR_DIRT_B: 11,
  FLOOR_DIRT_C: 12,
  FLOOR_DIRT_D: 13,
  FLOOR_GRASS_A: 14,
  FLOOR_GRASS_B: 15,
  FLOOR_GRASS_C: 16,

  // Row 1: More floors
  FLOOR_GRASS_D: 17,
  FLOOR_WOOD_A: 18,
  FLOOR_WOOD_B: 19,
  FLOOR_WOOD_C: 20,
  FLOOR_WOOD_D: 21,
  FLOOR_TILE_A: 22,
  FLOOR_TILE_B: 23,
  FLOOR_TILE_C: 24,
  FLOOR_TILE_D: 25,
  FLOOR_CARPET_A: 26,
  FLOOR_CARPET_B: 27,
  FLOOR_CARPET_C: 28,
  FLOOR_CARPET_D: 29,
  FLOOR_CARPET_E: 30,
  FLOOR_MOSSY_A: 31,
  FLOOR_MOSSY_B: 32,
  FLOOR_MOSSY_C: 33,

  // Row 2: Stone walls horizontal
  WALL_STONE_H_A: 34,
  WALL_STONE_H_B: 35,
  WALL_STONE_H_C: 36,
  WALL_STONE_H_CRACK: 37,
  WALL_STONE_H_D: 38,
  WALL_STONE_H_E: 39,
  WALL_STONE_POOL_EMPTY: 40,
  WALL_STONE_POOL_FULL: 41,
  WALL_STONE_STAIR_DOWN: 42,
  WALL_STONE_STAIR_UP: 43,

  // Row 3: Stone walls vertical
  WALL_STONE_V_A: 51,
  WALL_STONE_V_B: 52,
  WALL_STONE_V_C: 53,
  WALL_STONE_V_CRACK: 54,
  WALL_STONE_V_D: 55,
  WALL_STONE_V_E: 56,

  // Row 4: Cave walls horizontal
  WALL_CAVE_H_A: 68,
  WALL_CAVE_H_B: 69,
  WALL_CAVE_H_C: 70,
  WALL_CAVE_H_CRACK: 71,
  WALL_CAVE_H_D: 72,
  WALL_CAVE_H_E: 73,
  WALL_CAVE_POOL_EMPTY: 74,
  WALL_CAVE_POOL_FULL: 75,
  WALL_CAVE_STAIR_DOWN: 76,
  WALL_CAVE_STAIR_UP: 77,

  // Row 5: Cave walls vertical
  WALL_CAVE_V_A: 85,
  WALL_CAVE_V_B: 86,
  WALL_CAVE_V_C: 87,
  WALL_CAVE_V_CRACK: 88,
  WALL_CAVE_V_D: 89,
  WALL_CAVE_V_E: 90,

  // Row 6: Crypt walls horizontal
  WALL_CRYPT_H_A: 102,
  WALL_CRYPT_H_B: 103,
  WALL_CRYPT_H_C: 104,
  WALL_CRYPT_H_CRACK: 105,
  WALL_CRYPT_H_D: 106,
  WALL_CRYPT_H_E: 107,
  WALL_CRYPT_POOL_EMPTY: 108,
  WALL_CRYPT_POOL_FULL: 109,
  WALL_CRYPT_STAIR_DOWN: 110,
  WALL_CRYPT_STAIR_UP: 111,

  // Row 7: Crypt walls vertical
  WALL_CRYPT_V_A: 119,
  WALL_CRYPT_V_B: 120,
  WALL_CRYPT_V_C: 121,
  WALL_CRYPT_V_CRACK: 122,
  WALL_CRYPT_V_D: 123,
  WALL_CRYPT_V_E: 124,

  // Row 8: Sewer walls horizontal
  WALL_SEWER_H_A: 136,
  WALL_SEWER_H_B: 137,
  WALL_SEWER_H_C: 138,
  WALL_SEWER_H_CRACK: 139,
  WALL_SEWER_H_D: 140,
  WALL_SEWER_H_E: 141,
  WALL_SEWER_POOL_EMPTY: 142,
  WALL_SEWER_POOL_FULL: 143,
  WALL_SEWER_STAIR_DOWN: 144,
  WALL_SEWER_STAIR_UP: 145,

  // Row 9: Sewer walls vertical
  WALL_SEWER_V_A: 153,
  WALL_SEWER_V_B: 154,
  WALL_SEWER_V_C: 155,
  WALL_SEWER_V_CRACK: 156,
  WALL_SEWER_V_D: 157,
  WALL_SEWER_V_E: 158,

  // Doors
  DOOR_STONE_H_CLOSED: 170,
  DOOR_STONE_H_OPEN: 171,
  DOOR_STONE_V_CLOSED: 172,
  DOOR_STONE_V_OPEN: 173,
  DOOR_GATE_H_CLOSED: 174,
  DOOR_GATE_H_OPEN: 175,
  DOOR_GATE_V_CLOSED: 176,
  DOOR_GATE_V_OPEN: 177,
  DOOR_EVIL_H_CLOSED: 178,
  DOOR_EVIL_H_OPEN: 179,
  DOOR_EVIL_V_CLOSED: 180,
  DOOR_EVIL_V_OPEN: 181,
  DOOR_WOOD_H_CLOSED: 182,
  DOOR_WOOD_H_OPEN: 183,
  DOOR_WOOD_V_CLOSED: 184,
  DOOR_WOOD_V_OPEN: 185,

  // Props
  CHEST_CLOSED: 187,
  CHEST_OPEN: 188,
  CRATE: 189,
  CRATE_BROKEN: 190,
  BARREL: 191,
  BARREL_BROKEN: 192,
  BOOKSHELF_A: 193,
  BOOKSHELF_B: 194,
  TABLE: 195,
  CHAIR: 196,
  BED: 197,
  CAULDRON_1: 198,
  CAULDRON_2: 199,
  CAMPFIRE_1: 200,
  CAMPFIRE_2: 201,
  CAMPFIRE_STONES: 202,
  CANDLES_A: 203,
  CANDLES_B: 204,
  CANDLES_C: 205,
  TORCH_1: 206,
  TORCH_2: 207,
  SKULL: 208,
  BONES_A: 209,
  BONES_B: 210,
  BLOOD_A: 211,
  BLOOD_B: 212,
  BLOOD_C: 213,
  STATUE: 214,
  FOUNTAIN: 215,
  WELL: 216,
  SIGN: 217,
  GRAVESTONE_A: 218,
  GRAVESTONE_B: 219,
  ALTAR: 220,
  THRONE: 221,
  BANNER_A: 222,
  BANNER_B: 223,
  FLAG: 224,
  RUG_A: 225,
  RUG_B: 226,
  COBWEB_A: 227,
  COBWEB_B: 228,
  MUSHROOM_A: 229,
  MUSHROOM_B: 230,
  VINES: 231,
  CRYSTAL: 232,
  ORB: 233,
  MIRROR: 234,
  WINDOW_A: 235,
  WINDOW_B: 236,
  LEVER_OFF: 237,
  LEVER_ON: 238,
  PRESSURE_PLATE: 239,
  SPIKE_TRAP: 240,
  PIT: 241,
  WATER_A: 242,
  WATER_B: 243,
  LAVA_A: 244,
  LAVA_B: 245,
  ACID_A: 246,
  ACID_B: 247,
} as const;

// ============================================================================
// MONSTERS (tiny_dungeon_monsters.png) - 29 columns
// Each monster has 8 frames: down1, down2, left1, left2, right1, right2, up1, up2
// Format: base index = first frame, add offset for direction
// ============================================================================
export const MONSTER_DIRECTIONS = {
  DOWN_1: 0,
  DOWN_2: 1,
  LEFT_1: 2,
  LEFT_2: 3,
  RIGHT_1: 4,
  RIGHT_2: 5,
  UP_1: 6,
  UP_2: 7,
} as const;

// Monster base indices (multiply row by 29 for each row)
// Each row contains ~3-4 monsters with 8 frames each
export const MONSTERS = {
  // Row 0-1: Human heroes
  FIGHTER: 0,
  BERSERKER: 8,
  KNIGHT: 16,
  PALADIN: 24,

  // Row 2-3: More heroes
  ROGUE: 58,
  ARCHER: 66,
  MERCENARY: 74,
  MINSTREL: 82,

  // Row 4-5: Magic users
  WIZARD: 116,
  WITCH: 124,
  NECROMANCER: 132,
  DRUID: 140,
  CLERIC: 148,

  // Row 6-7: Undead
  ZOMBIE: 174,
  MUMMY: 182,
  VAMPIRE: 190,
  WRAITH: 198,
  REAPER: 206,

  // Row 8-9: Demons
  DEMON: 232,
  VOID: 240,
  FLAME: 248,

  // Row 10-11: Beasts
  RAT: 290,
  BAT: 298,
  SPIDER: 306,
  WOLF: 314,
  CAT: 322,

  // Row 12-13: Creatures
  SNAKE: 348,
  JELLY: 356,
  SLIME: 364,
  BEETLE: 372,
  MOTH: 380,
  FLIES: 388,

  // Row 14-15: Mythical creatures
  MINOTAUR: 406,
  CENTAUR: 414,
  SATYR: 422,
  TROLL: 430,
  GIANT: 438,

  // Row 16: Special - Note: These are remapped to valid frames within the 464-frame spritesheet
  // The spritesheet has 29 columns x 16 rows = 464 frames (0-463)
  BEHOLDER: 232,   // Using DEMON frame as stand-in
  PHOENIX: 248,    // Using FLAME frame
  DRAGON: 240,     // Using VOID frame (large monster)
  GRIFFIN: 248,    // Using FLAME frame
  UNICORN: 140,    // Using DRUID frame
  TREANT: 430,     // Using TROLL frame (large creature)
  ELEMENTAL: 248,  // Using FLAME frame
  PLANT: 364,      // Using SLIME frame

  // NPCs - remapped to valid frames
  MERCHANT: 82,    // Using MINSTREL frame
  KING: 24,        // Using PALADIN frame
  QUEEN: 124,      // Using WITCH frame
  ANGEL: 148,      // Using CLERIC frame

  // Small creatures - remapped to valid frames
  HOBBIT: 58,      // Using ROGUE frame
  DWARF: 0,        // Using FIGHTER frame
  PIXIE: 124,      // Using WITCH frame (small magic user)
  MIMIC: 182,      // Using MUMMY frame (chest mimic)
  YETI: 430,       // Using TROLL frame
} as const;

// ============================================================================
// ITEMS (tiny_dungeon_items.png) - 23 columns
// ============================================================================
export const ITEMS = {
  // Row 0: Weapons
  SWORD_IRON: 0,
  SWORD_STEEL: 1,
  SWORD_MAGIC: 2,
  AXE_IRON: 3,
  AXE_STEEL: 4,
  AXE_MAGIC: 5,
  STAFF_WOOD: 6,
  STAFF_MAGIC: 7,
  STAFF_CRYSTAL: 8,
  BOW: 9,
  CROSSBOW: 10,
  DAGGER: 11,
  HAMMER: 12,
  SPEAR: 13,
  MACE: 14,
  WAND: 15,

  // Row 1: Armor
  HELM_LEATHER: 23,
  HELM_IRON: 24,
  HELM_MAGIC: 25,
  CHEST_LEATHER: 26,
  CHEST_IRON: 27,
  CHEST_MAGIC: 28,
  GLOVE_LEATHER: 29,
  GLOVE_IRON: 30,
  GLOVE_MAGIC: 31,
  BOOT_LEATHER: 32,
  BOOT_IRON: 33,
  BOOT_MAGIC: 34,
  SHIELD_WOOD: 35,
  SHIELD_IRON: 36,
  SHIELD_MAGIC: 37,
  CAPE_LEATHER: 38,
  CAPE_MAGIC: 39,

  // Row 2: Potions and consumables
  POTION_RED: 46,
  POTION_BLUE: 47,
  POTION_GREEN: 48,
  POTION_PURPLE: 49,
  POTION_YELLOW: 50,
  FLASK_RED: 51,
  FLASK_BLUE: 52,
  FLASK_GREEN: 53,
  HERB_GREEN: 54,
  HERB_RED: 55,
  HERB_GOLD: 56,
  BANDAGE: 57,

  // Row 3: Keys and treasures
  KEY_GOLD: 69,
  KEY_SILVER: 70,
  KEY_SKELETON: 71,
  KEY_MAGIC: 72,
  COINS_COPPER: 73,
  COINS_SILVER: 74,
  COINS_GOLD: 75,
  GEM_RUBY: 76,
  GEM_SAPPHIRE: 77,
  GEM_JADE: 78,
  GEM_AMETHYST: 79,
  GEM_GARNET: 80,
  CROWN_GOLD: 81,
  CROWN_SILVER: 82,
  CROWN_EVIL: 83,

  // Row 4: Accessories and misc
  AMULET_GOLD: 92,
  AMULET_SILVER: 93,
  AMULET_MAGIC: 94,
  RING_GOLD: 95,
  RING_SILVER: 96,
  RING_MAGIC: 97,
  BOOK_BROWN: 98,
  BOOK_BLACK: 99,
  BOOK_GREEN: 100,
  SCROLL: 101,
  COMPASS: 102,
  CROSS: 103,
  FEATHER: 104,
  CRYSTAL_EMPTY: 105,
  CRYSTAL_FULL: 106,

  // Row 5: Projectiles and tools
  ARROW: 115,
  BOLT: 116,
  DARTS: 117,
  CALTROPS: 118,
  BOMB: 119,
  TORCH: 120,
  LANTERN: 121,
  PICKAXE: 122,
  ROPE: 123,

  // Hearts (for UI)
  HEART_FULL: 124,
  HEART_EMPTY: 125,
} as const;

// ============================================================================
// INTERFACE ELEMENTS (for 9-slice panels, buttons, etc.)
// ============================================================================
export const INTERFACE = {
  // Stone panel 9-slice (3x3 grid)
  PANEL_STONE: {
    TL: 0, TC: 1, TR: 2,
    ML: 3, MC: 4, MR: 5,
    BL: 6, BC: 7, BR: 8,
  },
  // Scroll panel 9-slice
  PANEL_SCROLL: {
    TL: 9, TC: 10, TR: 11,
    ML: 12, MC: 13, MR: 14,
    BL: 15, BC: 16, BR: 17,
  },
  // Window panel
  PANEL_WINDOW: {
    TL: 18, TC: 19, TR: 20,
    ML: 21, MC: 22, MR: 23,
    BL: 24, BC: 25, BR: 26,
  },
  // Buttons
  BUTTON_STONE: 27,
  BUTTON_STONE_PRESS: 28,
  BUTTON_SCROLL: 29,
  BUTTON_SCROLL_PRESS: 30,
  // Close buttons
  CLOSE_STONE: 31,
  CLOSE_STONE_PRESS: 32,
  CLOSE_SCROLL: 33,
  CLOSE_SCROLL_PRESS: 34,
  // Checkboxes
  CHECK_STONE: 35,
  CHECK_STONE_CHECKED: 36,
  CHECK_SCROLL: 37,
  CHECK_SCROLL_CHECKED: 38,
  // HP/MP bars
  HP_FULL: { LEFT: 39, MID: 40, RIGHT: 41 },
  HP_EMPTY: { LEFT: 42, MID: 43, RIGHT: 44 },
  MP_FULL: { LEFT: 45, MID: 46, RIGHT: 47 },
  MP_EMPTY: { LEFT: 48, MID: 49, RIGHT: 50 },
  // Hearts
  HEART_FULL: 51,
  HEART_EMPTY: 52,
  // Crystal (mana)
  CRYSTAL_FULL: 53,
  CRYSTAL_EMPTY: 54,
  // Option buttons
  OPTION_ATTACK: 55,
  OPTION_ATTACK_PRESS: 56,
  OPTION_DEFEND: 57,
  OPTION_DEFEND_PRESS: 58,
  OPTION_MAGIC: 59,
  OPTION_MAGIC_PRESS: 60,
  OPTION_ITEM: 61,
  OPTION_ITEM_PRESS: 62,
  OPTION_BAG: 63,
  OPTION_BAG_PRESS: 64,
  OPTION_EQUIP: 65,
  OPTION_EQUIP_PRESS: 66,
  OPTION_SETTING: 67,
  OPTION_SETTING_PRESS: 68,
  OPTION_GO: 69,
  OPTION_GO_PRESS: 70,
  OPTION_CANCEL: 71,
  OPTION_CANCEL_PRESS: 72,
  // Cursors
  CURSOR_ARROW: 73,
  CURSOR_POINTER: 74,
  CURSOR_HAND: 75,
  CURSOR_TARGET: 76,
  // Bubbles (speech/thought)
  BUBBLE: {
    TL: 77, TC: 78, TR: 79,
    ML: 80, MC: 81, MR: 82,
    BL: 83, BC: 84, BR: 85,
  },
  BUBBLE_ARROW_L: 86,
  BUBBLE_ARROW_M: 87,
  BUBBLE_ARROW_R: 88,
  // Selection frames
  SELECT_A: 89,
  SELECT_B: 90,
  SELECT_C: 91,
  SELECT_D: 92,
  SELECT_E: 93,
  SELECT_F: 94,
} as const;

// ============================================================================
// FX / EFFECTS
// ============================================================================
export const FX = {
  // Projectiles (8 directions)
  FIREBALL: { C: 0, N: 1, NE: 2, E: 3, SE: 4, S: 5, SW: 6, W: 7, NW: 8 },
  ICEBALL: { C: 9, N: 10, NE: 11, E: 12, SE: 13, S: 14, SW: 15, W: 16, NW: 17 },
  ACIDBALL: { C: 18, N: 19, NE: 20, E: 21, SE: 22, S: 23, SW: 24, W: 25, NW: 26 },
  VOIDBALL: { C: 27, N: 28, NE: 29, E: 30, SE: 31, S: 32, SW: 33, W: 34, NW: 35 },
  // Impact effects (3 frames each)
  FIRE_IMPACT: [36, 37, 38],
  ICE_IMPACT: [39, 40, 41],
  ACID_IMPACT: [42, 43, 44],
  VOID_IMPACT: [45, 46, 47],
  // Burn effects (2 frames each)
  FIRE_BURN: [48, 49],
  ICE_BURN: [50, 51],
  ACID_BURN: [52, 53],
  VOID_BURN: [54, 55],
  // Spark effects (2 frames each)
  FIRE_SPARK: [56, 57],
  ICE_SPARK: [58, 59],
  ACID_SPARK: [60, 61],
  VOID_SPARK: [62, 63],
  // Physical attacks
  SLASH: [64, 65, 66],
  SLASH2: [67, 68, 69],
  CUT: [70, 71, 72],
  PIERCE: [73, 74, 75],
  BASH: [76, 77, 78],
  SWING: [79, 80, 81],
  // Status effects
  POISON: [82, 83],
  SPARKLE: [84, 85, 86],
  SMOKE: [87, 88],
  // Environmental
  BUBBLE: [89, 90, 91],
  DRIP: [92, 93, 94],
  RAIN: [95, 96],
  // Lightning/Zap (8 directions)
  LIGHTNING: [97, 98],
  ZAP: [99, 100, 101, 102, 103, 104, 105, 106],
  // Arrows (8 directions)
  ARROW: [107, 108, 109, 110, 111, 112, 113, 114],
} as const;

// ============================================================================
// PORTRAIT CLASSES (for character select/display)
// Each class has 5 variants x 2 genders = 10 portraits
// ============================================================================
export const PORTRAIT_CLASSES = [
  'fighter', 'berserker', 'knight', 'paladin', 'rogue', 'archer',
  'mercenary', 'minstrel', 'wizard', 'witch', 'necromancer', 'druid', 'cleric'
] as const;

export type PortraitClass = typeof PORTRAIT_CLASSES[number];

// Helper to get portrait filename
export function getPortraitPath(
  charClass: PortraitClass,
  variant: 1 | 2 | 3 | 4 | 5,
  gender: 'm' | 'f'
): string {
  return `assets/oryx_tiny_dungeon/td_sliced/td_portraits/td_portrait_${charClass}_${variant}${gender}.png`;
}

// ============================================================================
// SUBJECT THEMES - Visual identity for each bar exam subject
// ============================================================================
export interface SubjectTheme {
  floor: number[];           // Array of floor tile indices (for variety)
  wallH: number[];           // Horizontal wall indices
  wallV: number[];           // Vertical wall indices
  door: number;              // Door tile index
  props: number[];           // Decorative prop indices
  monster: number;           // Monster base frame for encounters
  bossMonster: number;       // Boss monster for final encounter
  ambientColor: number;      // Tint color for atmosphere
  floorColor?: number;       // Optional floor tint
  particleColor?: number;    // Particle effect color
}

export const SUBJECT_THEMES: Record<string, SubjectTheme> = {
  'Agency': {
    floor: [WORLD_TILES.FLOOR_WOOD_A, WORLD_TILES.FLOOR_WOOD_B, WORLD_TILES.FLOOR_WOOD_C],
    wallH: [WORLD_TILES.WALL_STONE_H_A, WORLD_TILES.WALL_STONE_H_B, WORLD_TILES.WALL_STONE_H_C],
    wallV: [WORLD_TILES.WALL_STONE_V_A, WORLD_TILES.WALL_STONE_V_B, WORLD_TILES.WALL_STONE_V_C],
    door: WORLD_TILES.DOOR_WOOD_V_CLOSED,
    props: [WORLD_TILES.TABLE, WORLD_TILES.CHAIR, WORLD_TILES.BOOKSHELF_A, WORLD_TILES.CANDLES_A],
    monster: MONSTERS.MERCHANT,
    bossMonster: MONSTERS.KING,
    ambientColor: 0x8844aa,
  },
  'Civil Procedure': {
    floor: [WORLD_TILES.FLOOR_TILE_A, WORLD_TILES.FLOOR_TILE_B, WORLD_TILES.FLOOR_TILE_C],
    wallH: [WORLD_TILES.WALL_STONE_H_A, WORLD_TILES.WALL_STONE_H_B, WORLD_TILES.WALL_STONE_H_D],
    wallV: [WORLD_TILES.WALL_STONE_V_A, WORLD_TILES.WALL_STONE_V_B, WORLD_TILES.WALL_STONE_V_D],
    door: WORLD_TILES.DOOR_STONE_V_CLOSED,
    props: [WORLD_TILES.BOOKSHELF_A, WORLD_TILES.BOOKSHELF_B, WORLD_TILES.TABLE, WORLD_TILES.CANDLES_B],
    monster: MONSTERS.SPIDER,
    bossMonster: MONSTERS.BEHOLDER,
    ambientColor: 0x4488aa,
  },
  'Con Law': {
    floor: [WORLD_TILES.FLOOR_CARPET_A, WORLD_TILES.FLOOR_CARPET_B, WORLD_TILES.FLOOR_CARPET_C],
    wallH: [WORLD_TILES.WALL_STONE_H_A, WORLD_TILES.WALL_STONE_H_B, WORLD_TILES.WALL_STONE_H_E],
    wallV: [WORLD_TILES.WALL_STONE_V_A, WORLD_TILES.WALL_STONE_V_B, WORLD_TILES.WALL_STONE_V_E],
    door: WORLD_TILES.DOOR_GATE_V_CLOSED,
    props: [WORLD_TILES.THRONE, WORLD_TILES.BANNER_A, WORLD_TILES.FLAG, WORLD_TILES.STATUE],
    monster: MONSTERS.DEMON,
    bossMonster: MONSTERS.DRAGON,
    ambientColor: 0xaa4444,
  },
  'Conflicts Of Law': {
    floor: [WORLD_TILES.FLOOR_MOSSY_A, WORLD_TILES.FLOOR_MOSSY_B, WORLD_TILES.FLOOR_MOSSY_C],
    wallH: [WORLD_TILES.WALL_CAVE_H_A, WORLD_TILES.WALL_CAVE_H_B, WORLD_TILES.WALL_CAVE_H_C],
    wallV: [WORLD_TILES.WALL_CAVE_V_A, WORLD_TILES.WALL_CAVE_V_B, WORLD_TILES.WALL_CAVE_V_C],
    door: WORLD_TILES.DOOR_STONE_V_CLOSED,
    props: [WORLD_TILES.TORCH_1, WORLD_TILES.SKULL, WORLD_TILES.BONES_A, WORLD_TILES.COBWEB_A],
    monster: MONSTERS.MINOTAUR,
    bossMonster: MONSTERS.GIANT,
    ambientColor: 0x44aa88,
  },
  'Contracts': {
    floor: [WORLD_TILES.FLOOR_WOOD_A, WORLD_TILES.FLOOR_WOOD_B, WORLD_TILES.FLOOR_WOOD_D],
    wallH: [WORLD_TILES.WALL_STONE_H_A, WORLD_TILES.WALL_STONE_H_C, WORLD_TILES.WALL_STONE_H_D],
    wallV: [WORLD_TILES.WALL_STONE_V_A, WORLD_TILES.WALL_STONE_V_C, WORLD_TILES.WALL_STONE_V_D],
    door: WORLD_TILES.DOOR_WOOD_V_CLOSED,
    props: [WORLD_TILES.BOOKSHELF_A, WORLD_TILES.TABLE, WORLD_TILES.CANDLES_A, WORLD_TILES.CHAIR],
    monster: MONSTERS.WIZARD,
    bossMonster: MONSTERS.NECROMANCER,
    ambientColor: 0xaaaa44,
  },
  'Corporations': {
    floor: [WORLD_TILES.FLOOR_TILE_A, WORLD_TILES.FLOOR_TILE_B, WORLD_TILES.FLOOR_TILE_D],
    wallH: [WORLD_TILES.WALL_STONE_H_A, WORLD_TILES.WALL_STONE_H_B, WORLD_TILES.WALL_STONE_H_E],
    wallV: [WORLD_TILES.WALL_STONE_V_A, WORLD_TILES.WALL_STONE_V_B, WORLD_TILES.WALL_STONE_V_E],
    door: WORLD_TILES.DOOR_GATE_V_CLOSED,
    props: [WORLD_TILES.CHEST_CLOSED, WORLD_TILES.BARREL, WORLD_TILES.CRATE, WORLD_TILES.TABLE],
    monster: MONSTERS.DWARF,
    bossMonster: MONSTERS.KING,
    ambientColor: 0x44aa44,
  },
  'Criminal Law': {
    floor: [WORLD_TILES.FLOOR_STONE_A, WORLD_TILES.FLOOR_STONE_B, WORLD_TILES.FLOOR_STONE_C],
    wallH: [WORLD_TILES.WALL_CRYPT_H_A, WORLD_TILES.WALL_CRYPT_H_B, WORLD_TILES.WALL_CRYPT_H_C],
    wallV: [WORLD_TILES.WALL_CRYPT_V_A, WORLD_TILES.WALL_CRYPT_V_B, WORLD_TILES.WALL_CRYPT_V_C],
    door: WORLD_TILES.DOOR_EVIL_V_CLOSED,
    props: [WORLD_TILES.TORCH_1, WORLD_TILES.SKULL, WORLD_TILES.BONES_A, WORLD_TILES.BLOOD_A],
    monster: MONSTERS.ZOMBIE,
    bossMonster: MONSTERS.REAPER,
    ambientColor: 0xaa8844,
  },
  'Criminal Procedure': {
    floor: [WORLD_TILES.FLOOR_STONE_A, WORLD_TILES.FLOOR_STONE_C, WORLD_TILES.FLOOR_STONE_D],
    wallH: [WORLD_TILES.WALL_CRYPT_H_A, WORLD_TILES.WALL_CRYPT_H_D, WORLD_TILES.WALL_CRYPT_H_E],
    wallV: [WORLD_TILES.WALL_CRYPT_V_A, WORLD_TILES.WALL_CRYPT_V_D, WORLD_TILES.WALL_CRYPT_V_E],
    door: WORLD_TILES.DOOR_GATE_V_CLOSED,
    props: [WORLD_TILES.TORCH_1, WORLD_TILES.SKULL, WORLD_TILES.BARREL, WORLD_TILES.COBWEB_A],
    monster: MONSTERS.WRAITH,
    bossMonster: MONSTERS.VAMPIRE,
    ambientColor: 0x8888aa,
  },
  'Evidence': {
    floor: [WORLD_TILES.FLOOR_WOOD_A, WORLD_TILES.FLOOR_WOOD_C, WORLD_TILES.FLOOR_WOOD_D],
    wallH: [WORLD_TILES.WALL_STONE_H_A, WORLD_TILES.WALL_STONE_H_B, WORLD_TILES.WALL_STONE_H_D],
    wallV: [WORLD_TILES.WALL_STONE_V_A, WORLD_TILES.WALL_STONE_V_B, WORLD_TILES.WALL_STONE_V_D],
    door: WORLD_TILES.DOOR_WOOD_V_CLOSED,
    props: [WORLD_TILES.BOOKSHELF_A, WORLD_TILES.BOOKSHELF_B, WORLD_TILES.CANDLES_B, WORLD_TILES.TABLE],
    monster: MONSTERS.BAT,
    bossMonster: MONSTERS.BEHOLDER,
    ambientColor: 0xaa4488,
  },
  'Family Law': {
    floor: [WORLD_TILES.FLOOR_CARPET_A, WORLD_TILES.FLOOR_CARPET_D, WORLD_TILES.FLOOR_CARPET_E],
    wallH: [WORLD_TILES.WALL_STONE_H_A, WORLD_TILES.WALL_STONE_H_B, WORLD_TILES.WALL_STONE_H_C],
    wallV: [WORLD_TILES.WALL_STONE_V_A, WORLD_TILES.WALL_STONE_V_B, WORLD_TILES.WALL_STONE_V_C],
    door: WORLD_TILES.DOOR_WOOD_V_CLOSED,
    props: [WORLD_TILES.BED, WORLD_TILES.TABLE, WORLD_TILES.CHAIR, WORLD_TILES.CANDLES_C],
    monster: MONSTERS.PIXIE,
    bossMonster: MONSTERS.QUEEN,
    ambientColor: 0xff8888,
  },
  'Partnerships': {
    floor: [WORLD_TILES.FLOOR_WOOD_A, WORLD_TILES.FLOOR_WOOD_B, WORLD_TILES.FLOOR_WOOD_C],
    wallH: [WORLD_TILES.WALL_STONE_H_A, WORLD_TILES.WALL_STONE_H_C, WORLD_TILES.WALL_STONE_H_E],
    wallV: [WORLD_TILES.WALL_STONE_V_A, WORLD_TILES.WALL_STONE_V_C, WORLD_TILES.WALL_STONE_V_E],
    door: WORLD_TILES.DOOR_WOOD_V_CLOSED,
    props: [WORLD_TILES.TABLE, WORLD_TILES.CHAIR, WORLD_TILES.CHEST_CLOSED, WORLD_TILES.BOOKSHELF_A],
    monster: MONSTERS.SATYR,
    bossMonster: MONSTERS.CENTAUR,
    ambientColor: 0x88ff88,
  },
  'Real Property': {
    floor: [WORLD_TILES.FLOOR_GRASS_A, WORLD_TILES.FLOOR_GRASS_B, WORLD_TILES.FLOOR_GRASS_C],
    wallH: [WORLD_TILES.WALL_CAVE_H_A, WORLD_TILES.WALL_CAVE_H_B, WORLD_TILES.WALL_CAVE_H_D],
    wallV: [WORLD_TILES.WALL_CAVE_V_A, WORLD_TILES.WALL_CAVE_V_B, WORLD_TILES.WALL_CAVE_V_D],
    door: WORLD_TILES.DOOR_STONE_V_CLOSED,
    props: [WORLD_TILES.CHEST_CLOSED, WORLD_TILES.BARREL, WORLD_TILES.MUSHROOM_A, WORLD_TILES.VINES],
    monster: MONSTERS.RAT,
    bossMonster: MONSTERS.TREANT,
    ambientColor: 0x88aaff,
  },
  'Secured Transactions': {
    floor: [WORLD_TILES.FLOOR_STONE_A, WORLD_TILES.FLOOR_STONE_B, WORLD_TILES.FLOOR_COBBLE_A],
    wallH: [WORLD_TILES.WALL_SEWER_H_A, WORLD_TILES.WALL_SEWER_H_B, WORLD_TILES.WALL_SEWER_H_C],
    wallV: [WORLD_TILES.WALL_SEWER_V_A, WORLD_TILES.WALL_SEWER_V_B, WORLD_TILES.WALL_SEWER_V_C],
    door: WORLD_TILES.DOOR_GATE_V_CLOSED,
    props: [WORLD_TILES.CHEST_CLOSED, WORLD_TILES.BARREL, WORLD_TILES.CRATE, WORLD_TILES.TORCH_1],
    monster: MONSTERS.SLIME,
    bossMonster: MONSTERS.JELLY,
    ambientColor: 0xffaa88,
  },
  'Torts': {
    floor: [WORLD_TILES.FLOOR_DIRT_A, WORLD_TILES.FLOOR_DIRT_B, WORLD_TILES.FLOOR_DIRT_C],
    wallH: [WORLD_TILES.WALL_CAVE_H_A, WORLD_TILES.WALL_CAVE_H_CRACK, WORLD_TILES.WALL_CAVE_H_E],
    wallV: [WORLD_TILES.WALL_CAVE_V_A, WORLD_TILES.WALL_CAVE_V_CRACK, WORLD_TILES.WALL_CAVE_V_E],
    door: WORLD_TILES.DOOR_STONE_V_CLOSED,
    props: [WORLD_TILES.SKULL, WORLD_TILES.BONES_A, WORLD_TILES.BLOOD_B, WORLD_TILES.COBWEB_B],
    monster: MONSTERS.WOLF,
    bossMonster: MONSTERS.TROLL,
    ambientColor: 0xff4444,
  },
  'Trusts And Estates': {
    floor: [WORLD_TILES.FLOOR_CARPET_A, WORLD_TILES.FLOOR_CARPET_B, WORLD_TILES.FLOOR_TILE_A],
    wallH: [WORLD_TILES.WALL_CRYPT_H_A, WORLD_TILES.WALL_CRYPT_H_B, WORLD_TILES.WALL_CRYPT_H_D],
    wallV: [WORLD_TILES.WALL_CRYPT_V_A, WORLD_TILES.WALL_CRYPT_V_B, WORLD_TILES.WALL_CRYPT_V_D],
    door: WORLD_TILES.DOOR_EVIL_V_CLOSED,
    props: [WORLD_TILES.GRAVESTONE_A, WORLD_TILES.BOOKSHELF_A, WORLD_TILES.CHEST_CLOSED, WORLD_TILES.CANDLES_A],
    monster: MONSTERS.MUMMY,
    bossMonster: MONSTERS.WRAITH,
    ambientColor: 0xffff88,
  },
};

// Helper to get random element from array
export function randomElement<T>(arr: T[]): T {
  return arr[Math.floor(Math.random() * arr.length)];
}

// Helper to get monster frame for specific direction
export function getMonsterFrame(baseIndex: number, direction: keyof typeof MONSTER_DIRECTIONS): number {
  return baseIndex + MONSTER_DIRECTIONS[direction];
}

// ============================================================================
// CHARACTER SELECTION OPTIONS
// ============================================================================

export interface CharacterOption {
  id: string;
  name: string;
  description: string;
  texture: string;
  frame: number; // Monster frame for the character
  stats: {
    hp: number;
    attack: number;
    defense: number;
  };
}

export const CHARACTER_OPTIONS: CharacterOption[] = [
  {
    id: 'kim',
    name: 'Kim Bardashian',
    description: 'A determined law student on her final chance to pass the bar.',
    texture: 'k1_kim_with_noclothing_and_noweapons',
    frame: 0, // Atlas uses frame names, not indices - 'k1_kim_with_noclothing_and_noweapons_0001'
    stats: { hp: 100, attack: 18, defense: 18 },
  },
  {
    id: 'knight',
    name: 'Knight',
    description: 'A sturdy warrior with balanced stats and reliable defense.',
    texture: 'monsters',
    frame: MONSTERS.KNIGHT,
    stats: { hp: 100, attack: 15, defense: 20 },
  },
  {
    id: 'wizard',
    name: 'Wizard',
    description: 'A magical scholar with high attack but low defense.',
    texture: 'monsters',
    frame: MONSTERS.WIZARD,
    stats: { hp: 80, attack: 25, defense: 10 },
  },
  {
    id: 'rogue',
    name: 'Rogue',
    description: 'A sneaky thief with quick attacks and moderate defense.',
    texture: 'monsters',
    frame: MONSTERS.ROGUE,
    stats: { hp: 90, attack: 20, defense: 15 },
  },
];

export function getCharacterOption(characterId: string): CharacterOption {
  // Handle undefined/null/empty characterId by returning default character
  if (!characterId) {
    console.warn('[getCharacterOption] No characterId provided, defaulting to "kim"');
    return CHARACTER_OPTIONS[0]; // 'kim' is the first character
  }

  const character = CHARACTER_OPTIONS.find(c => c.id === characterId);
  if (!character) {
    console.warn(`[getCharacterOption] Character with id '${characterId}' not found, defaulting to "kim"`);
    return CHARACTER_OPTIONS[0]; // Fall back to default character
  }
  return character;
}
